import { useCallback, useState } from "react";

export function useSceneModal() {
  const [modalState, setModalState] = useState({ isOpen: false, scene: null });

  const openModal = useCallback((scene) => {
    setModalState({ isOpen: true, scene });
  }, []);

  const closeModal = useCallback(() => {
    setModalState({ isOpen: false, scene: null });
  }, []);

  return { modalState, openModal, closeModal };
}
